import DetailArticlePageHeader from "@components/common/DetailArticlePageHeader";
import DetailPageLayout from "@components/common/DetailPageLayout";
import StrapiContent from "@components/common/StrapiContent";
import MainWrapper from "@components/pages/common/MainWrapper";
import { RAQ_PAGE_TYPE } from "@components/utils/constants";
import { IPageProps } from "@customTypes/commonResponses";
import DetailsPageSectionsWrapper from "@modules/detailsPage/DetailsPageSectionsWrapper";

const PageView = ({
  page,
  raqFormType,
  topNavigation,
  ogImage,
}: IPageProps): JSX.Element => {
  return (
    <MainWrapper>
      <DetailPageLayout>
        <DetailArticlePageHeader
          title={page.Title}
          blurb={page.Blurb}
          ogImage={ogImage}
        />
        <DetailsPageSectionsWrapper
          topNavigation={topNavigation}
          raqFormType={
            page.PageType === "terms_of_service" ? undefined : raqFormType
          }
          pageType={RAQ_PAGE_TYPE.PAGE}
        >
          <div className="px-5 desktop:px-0">
            <StrapiContent
              overview={page.Overview}
              description={page.Long_Description}
            />
          </div>
        </DetailsPageSectionsWrapper>
      </DetailPageLayout>
    </MainWrapper>
  );
};

export default PageView;
